import ReactDOM from "react-dom";
import HotTable from 'react-handsontable';

import BaseComponent from "../../../baseComponent.js";
import FormulaBar from "../legend-config/formulaBar.jsx";
import AppConfig from "../../../../config/config.js";

export default class Spreadsheet extends BaseComponent {
  constructor(props) {
    super(props);
    this.handsontableData = [];
    this.state = {
      currentCellCoords: null,
      legend: this.props.legends[0]
    };
    // this.setDefaultData();
  }

  componentDidMount() {
    const settings = {
      data: this.handsontableData,
      afterOnCellMouseDown: this.handleAfterOnCellMouseDown,
      colHeaders: true,
      rowHeaders: true,
      contextMenu: true,
      mergeCells: true,
      outsideClickDeselects: false,
      disabled: true,
    };

    ReactDOM.render(<HotTable settings={settings}/>, this.refs.hotTable);
  }

  setDefaultData() {
    const defaultSize = 4;
    for (let i = 0; i < defaultSize; i++) {
      const dataRow = [];
      for (let j = 0; j < defaultSize; j++) {
        dataRow.push("");
        this.legends.push(null);
      }
      this.handsontableData.push(dataRow);
    }
  }

  getDefaultLegend(coords) {
    return {
      id: coords.row + ":" + coords.col,
      expressions: {
        y: ""
      },
      mappings: {},
      parameters: {}
    };
  }

  handleAfterOnCellMouseDown(event, coords, ele) {
    const legend = this.legends[coords.row][coords.col];
    if (!legend) {
      this.legends[coords.row][coords.col] = this.getDefaultLegend(coords);
    }
    this.setState({
      legend: legend.expression.y,
      currentCellCoords: coords
    });
  }

  handleFormulaChange(event) {
    const coords = this.state.currentCellCoords;
    this.setState({
      formula: event.target.value
    });
    this.handsontableData[coords.row][coords.col] = event.target.value;
  }

  render() {
    let component;
    for (let componentId in this.props.components) {
      component = this.props.components[componentId];
    }


    return (
      <div>
        <div>
          {
            this.state.legend ?
              <FormulaBar colors={AppConfig.EXTENDED_LEGEND_COLORS.slice()}
                          expressionKey={"y"}
                          updateExpression={(key, val) => this.props.onLegendChange(val)}
                          expression={this.state.legend.expressions.y}
                          mappings={this.state.ex.mappings}
                          callback={this.props.callback}
                          dashboardVariables={this.props.dashboardVariables}/> : null
          }
        </div>
        <div ref="hotTable"/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/spreadsheet.jsx